import { render, staticRenderFns } from "./ProfileActivities.vue?vue&type=template&id=6d18049b&scoped=true&"
import script from "./ProfileActivities.vue?vue&type=script&setup=true&lang=js&"
export * from "./ProfileActivities.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d18049b",
  null
  
)

export default component.exports